import * as React from 'react';
import styled from '@emotion/styled';

import './modal.scss';
import { ReactComponent as Close } from '../../assets/images/close.svg';
import styleGuide from 'constants/styleGuide';
import { IEmpSch } from 'types/dashboard';

const ModalBackground = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
`;

const EmptyEmp = styled.div`
  flex: 1;
  display: flex;
  padding: 20% 0;
  justify-content: center;
`;
const EmptyEmpText = styled.span`
  color: ${styleGuide.palette.greyColor};
`;

interface Props {
  isVisible: boolean;
  onClose: Function;
  headerText: string;
  subHeaderText?: string;
  modalType: string;
  tableHeads?: Array<string>;
  tableData?: IEmpSch[];
  enterDetailInfo: (empData: IEmpSch) => void;
}

const Modal: React.FunctionComponent<Props> = ({
  isVisible,
  onClose,
  headerText,
  subHeaderText,
  modalType,
  tableHeads,
  tableData,
  enterDetailInfo,
}) => {
  const onCloseModal = () => {
    onClose(false);
  };

  if (!isVisible) return null;
  return (
    <div className="modal">
      <ModalBackground onClick={onCloseModal} />
      <div className="modal-content">
        <div className="modal-action">
          <div className="modal-action__close" onClick={onCloseModal}>
            <Close />
          </div>
        </div>
        <div className="modal-head">
          <div className="modal-header">{headerText}</div>
          <div className="modal-subheader">{subHeaderText}</div>
        </div>
        <div className="modal-body">
          <table className="modal-table">
            <thead>
              <tr className="modal-tr">
                {tableHeads &&
                  tableHeads.map((head) => (
                    <th className="modal-th" key={head}>
                      {head}
                    </th>
                  ))}
              </tr>
            </thead>
            <tbody>
              {tableData &&
                tableData.length > 0 &&
                tableData.map((data) => (
                  <tr className="modal-tr__content" key={`list_${headerText}_${data.empSeq}`}>
                    {tableHeads &&
                      tableHeads.map((ele: string) => (
                        <td className="modal-td" key={`${ele}_${data.empSeq}`}>
                          {
                            <div>
                              {ele === '자세히' && (
                                <div onClick={() => enterDetailInfo(data)}>
                                  <span className="modal-detail">
                                    {headerText === '합류대기' ? '승인하기' : '정보보기'}
                                  </span>
                                </div>
                              )}
                              {ele === '이름' && (
                                <div className="modal-profile">
                                  {!(headerText === '합류대기') && (
                                    <div className="modal-profile__div">
                                      <img
                                        className="modal-profile__image"
                                        src={
                                          'https://post.medicalnewstoday.com/wp-content/uploads/sites/3/2020/03/GettyImages-1092658864_thumb-732x549.jpg'
                                        }
                                        alt="profImage"
                                      />
                                    </div>
                                  )}
                                  <div className="modal-profile__username">{data['empName']}</div>
                                </div>
                              )}
                              {ele === '직책' && <div className="modal-profile__duty">{data['isManager']}</div>}
                              {ele === '근무유형' && (
                                <div className="type-of-work-label">
                                  {data['workType'] === '고정' ? (
                                    <div className="type-of-work-label__fixed">
                                      <strong>{data['workType']}</strong>
                                    </div>
                                  ) : (
                                    <div className="type-of-work-label__going-to">
                                      <strong>{data['workType']}</strong>
                                    </div>
                                  )}
                                </div>
                              )}
                              {ele === '출근예정' && <div className="modal-profile__time">{data['workStartTime']}</div>}
                              {ele === '출근시간' && <div className="modal-profile__time">{data['realStartTime']}</div>}
                              {ele === '퇴근예정' && <div className="modal-profile__time">{data['workEndTime']}</div>}
                              {ele === '퇴근시간' && <div className="modal-profile__time">{data['realEndTime']}</div>}
                              {ele === '휴대폰번호' && <div className="modal-profile__other">{data['phone']}</div>}
                              {ele === '초대날짜' && <div className="modal-profile__other">{data['invitedDate']}</div>}
                            </div>
                          }
                        </td>
                      ))}
                  </tr>
                ))}
            </tbody>
          </table>
          {!tableData ||
            (tableData.length === 0 && (
              <EmptyEmp>
                <EmptyEmpText>해당 직원이 없습니다</EmptyEmpText>
              </EmptyEmp>
            ))}
        </div>
      </div>
    </div>
  );
};
export default Modal;
